import { Link } from 'react-router-dom';
import { Phone, Mail, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#111111] text-white py-16 md:py-20 border-t border-[#D1CCC2]/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="col-span-1">
            <div className="flex flex-col items-start mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_studio-replica-18/artifacts/pryjb7qe_acad%20studio-Black.png" 
                alt="Acad Studio" 
                className="h-12 brightness-0 invert"
              />
            </div>
            <p className="text-sm text-white/60 font-sans leading-relaxed font-light">
              Creating spaces that inspire, endure, and enrich the way people live.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-serif text-white mb-6 uppercase tracking-[0.2em]">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-white/60 hover:text-[#9C8454] transition-colors font-sans" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services/architecture-design" className="text-sm text-white/60 hover:text-[#9C8454] transition-colors font-sans" data-testid="footer-link-services">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white/60 hover:text-[#9C8454] transition-colors font-sans" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-serif text-white mb-6 uppercase tracking-[0.2em]">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services/architecture-design" className="text-sm text-white/60 hover:text-[#9C8454] transition-colors font-sans">
                  Architecture Design
                </Link>
              </li>
              <li>
                <Link to="/services/interior-design" className="text-sm text-white/60 hover:text-[#9C8454] transition-colors font-sans">
                  Interior Design
                </Link>
              </li>
              <li>
                <Link to="/services/pmc" className="text-sm text-white/60 hover:text-[#9C8454] transition-colors font-sans">
                  Project Management
                </Link>
              </li>
              <li>
                <a href="https://acadhome.co.in" target="_blank" rel="noopener noreferrer" className="text-sm text-white/60 hover:text-[#9C8454] transition-colors font-sans">
                  Home Decor
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-serif text-white mb-6 uppercase tracking-[0.2em]">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-sm text-white/60 font-sans">
                <Phone className="w-4 h-4 text-[#9C8454]" />
                <a href="tel:+919205891804" className="hover:text-[#9C8454] transition-colors" data-testid="footer-phone">
                  +91 92058 91804
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/60 font-sans">
                <Mail className="w-4 h-4 text-[#9C8454]" />
                <a href="mailto:info@acad.co.in" className="hover:text-[#9C8454] transition-colors" data-testid="footer-email">
                  info@acad.co.in
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/60 font-sans">
                <Instagram className="w-4 h-4 text-[#9C8454]" />
                <a
                  href="https://instagram.com/acadstudio_"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#9C8454] transition-colors"
                  data-testid="footer-instagram"
                >
                  @acadstudio_
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60 font-sans font-light">
              © {new Date().getFullYear()} Acad Studio Pvt Ltd. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="text-sm text-white/60 hover:text-[#9C8454] transition-colors font-sans" data-testid="footer-privacy">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-sm text-white/60 hover:text-[#9C8454] transition-colors font-sans" data-testid="footer-terms">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
